import { AbstractPmsApiService } from './abstract.service';

/**
 * @class BillingBankPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<>}
 */
export class BillingBankPmsApiService extends AbstractPmsApiService {

    static get $inject() {

        return [
            '$translate',
        ].concat(super.$inject);
    }

    constructor($translate, ...params) {

        super(...params);

        this.$translate = $translate;
    }

    /**
     * @returns {Promise<Array>}
     */
    get() {

        return Promise.resolve([
            {id: 1, name: this.$translate.instant('SAUDI_NATIONAL_BANK')},
            {id: 2, name: this.$translate.instant('SAUDI_BRITISH_BANK')},
            {id: 3, name: this.$translate.instant('SAUDI_INVESTMENT_BANK')},
            {id: 4, name: this.$translate.instant('ALINMA_BANK')},
            {id: 5, name: this.$translate.instant('BANQUE_SAUDI_FRANSI')},
            {id: 6, name: this.$translate.instant('RIYAD_BANK')},
            {id: 8, name: this.$translate.instant('ALAWWAL_BANK')},
            {id: 9, name: this.$translate.instant('AL_RAJHI_BANK')},
            {id: 10, name: this.$translate.instant('ARAB_NATIONAL_BANK')},
            {id: 11, name: this.$translate.instant('BANK_ALBILAD')},
            {id: 12, name: this.$translate.instant('BANK_ALJAZIRA')},
            {id: 13, name: this.$translate.instant('GULF_INTERNATIONAL_BANK')},
            {id: 14, name: this.$translate.instant('EMIRATES_NBD')},
            {id: 15, name: this.$translate.instant('NATIONAL_BANK_OF_BAHRAIN')},
            {id: 16, name: this.$translate.instant('NATIONAL_BANK_OF_KUWAIT')},
            {id: 17, name: this.$translate.instant('BANK_MUSCAT')},
            {id: 18, name: this.$translate.instant('OTHER')},
        ]);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/billing-bank.service.js